import { createAuthClient } from 'better-auth/react';

// No baseURL override: relative requests hit /api/auth/* on the same origin
// as the page (through Vite's dev proxy in development, nginx in
// production) — same reasoning as http.ts's axios client, and it's what
// keeps the session cookie same-origin instead of cross-site.
export const authClient = createAuthClient();

export const { useSession, signIn, signOut, signUp } = authClient;
